jQuery(document).ready(function($) {
    // if (is_dev) {
    //     add_students(127);
    // }
});

(function ($) {
    var reloadElementAjax = {};
    $.fn.reloadThisElement = function (cb, nextPage, getRequestData = false) {
        let requestData = {};
        this.each(function () {
            var elm = $(this);
            if (elm.attr('data-day-overview')) {
                elm.trigger('onReload');
                return;
            }
            const reveal = $(this).parents('.reveal');

            const load = () => {

                let uid;
                if (elm.attr('id') === undefined) {
                    uid = get_unique_id();
                    elm.attr('id', uid);
                } else {
                    uid = elm.attr('id');
                }
                if (elm.parent().html() === undefined) {
                    elm = $('#' + elm.attr('id'));
                }
                var attributes = {};
                $.each(this.attributes, function () {
                    // this.attributes is not a plain object, but an array
                    // of attribute nodes, which contain both the name and value
                    if (this.specified) {
                        attributes[this.name] = this.value;
                    } else {
                        attributes[this.name] = this.name;
                    }
                });

                var max_per_page = elm.attr('data-max-per-page') === undefined ? 30 : elm.attr('data-max-per-page');
                let current_page;
                if (!getRequestData) {

                    if (elm[0].current_page === undefined || nextPage === undefined) {
                        elm[0].current_page = 1;
                    } else if (nextPage) {
                        elm[0].current_page = nextPage;
                    }
                    current_page = elm[0].current_page;
                    if (current_page === 1 && elm[0].done) {
                        delete elm[0].done;
                    }
                } else {
                    current_page = nextPage;
                }

                var url = elm.attr('data-reloadable-url');
                var sendData = {};

                if (elm.attr('data-filters-key') !== undefined) {
                    var filters_key = elm.attr('data-filters-key');
                    var unique_id = get_unique_id();
                    $('body').append('<form id="' + unique_id + '" style="display: none;"></form>');
                    var form = $('#' + unique_id);
                    $(':input[data-' + filters_key + '-filter]').each(function () {
                        const input = $(this);
                        let event = ['text', 'password', 'email', 'number', 'date', 'search', 'tel', 'month', 'week'].indexOf(input.attr('type')) >= 0 ? 'keyup' : 'change';
                        if ($(this).is('textarea')) {
                            event = 'keyup';
                        }
                        if (input.is('[onclick="init_and_open_datepicker(this)"]') || input.is('[data-datepicker]')) {
                            event = 'change';
                        }

                        $(this).unbind('keyup.reloadElement change.reloadElement').bind(event + '.reloadElement', function () {
                            if (elm[0].delay) {
                                clearTimeout(elm[0].delay);
                            }
                            elm[0].delay = setTimeout(function() {
                                elm.reloadThisElement(cb);
                            }, 10);
                        }.bind([elm]));
                        var v = $(this).val();
                        var c = $(this).clone();
                        c.val(v);
                        form.append(c);
                    });
                    sendData = form.serializeJSON();
                    form.remove();
                }


                if (reloadElementAjax[uid] !== undefined && reloadElementAjax[uid].readyState !== 4) {
                    reloadElementAjax[uid].abort();
                }
                if (!getRequestData) {
                    elm.isLoading();
                }

                //Check for checked items, and take them with you un the selection!
                let checkedItems = [];
                if (elm.find('input[type=checkbox]:checked').length > 0) {
                    var checked = [];
                    elm.find('tbody:first').find('tr:has(input[type=checkbox]:checked)').each(function () {
                        checked.push($(this).attr('data-id'));
                    });

                    if (elm[0]['checked_items']) {
                        elm[0]['checked_items'].forEach(function (item) {
                            const input = elm.find('tbody:first').find('input[type=checkbox][value="' + item + '"]');
                            if (input.length === 0 || input.is(':checked')) {
                                checked.push(item);
                            }
                        });
                    }
                    checkedItems = checked;
                } else if (elm[0]['checked_items']) {
                    checkedItems = elm[0]['checked_items'];
                }

                if (cb !== undefined) {
                    if (!elm[0]['custom_callbacks']) {
                        elm[0]['custom_callbacks'] = [];
                    }
                    var same = false;
                    elm[0]['custom_callbacks'].forEach(function (fn) {
                        if (fn.toString() == cb.toString()) {
                            same = true;
                        }
                    });
                    if (same === false) {
                        elm[0]['custom_callbacks'].push(cb);
                    }
                }

                if (!getRequestData) {
                    elm[0].is_loading = true;
                }

                if (!elm.is('[data-no-paginator]')) {
                    sendData.max_per_page = max_per_page;
                    sendData.page = current_page;
                }

                const type = elm.attr('data-request-type') === undefined ? 'GET' : elm.attr('data-request-type');

                requestData = {
                    url,
                    type,
                    data: sendData,
                };

                if (!getRequestData) {
                    const last_url = elm[0].last_url;
                    reloadElementAjax[uid] = $.ajax({
                        url: url,
                        type: type,
                        data: sendData,
                        beforeSend: function (jqXHR, settings) {
                            elm[0].last_url = settings.url;
                            if (type !== 'GET') {
                                elm[0].last_data = sendData;
                            }
                        }
                    }).done(function (data) {
                        const elm = $('#' + uid);

                        let new_html = $($.parseHTML(data));

                        if (elm[0] === undefined) {
                            return;
                        }
                        const events = $._data(elm[0]).events;

                        const elmTag = elm.prop('tagName');
                        const newTag = new_html.prop('tagName');
                        if (elmTag !== newTag) {
                            //If its a table, and the new html is a div, replace it
                            elm.replaceWith(new_html);
                            $.each(attributes, function (name, value) {
                                if (value === undefined) {
                                    value = name;
                                }
                                new_html.attr(name, value);
                            });
                        } else {
                            //If its a table, and the new html is also a table, dont replace it, but replace it's contents, so that events remain safe
                            //First, add all of the new attributes to the existing elm
                            //Do everything except the classname, because that will lose its original value

                            if (elm.find('tbody:first').length > 0 && elm[0].current_page > 1 && nextPage) {
                                if (new_html.find('tbody:first tr[data-id]').length === 0) {
                                    elm[0].done = true;
                                }

                                if (elm.find('.check-whole-table').is(':checked')) {
                                    new_html.find('tr[data-id] input[type="checkbox"]').attr('checked', 'checked');
                                }

                                elm.find('tbody:first tr[data-id]:not(.checked-rows):last').after(new_html.find('tbody:first tr[data-id]'));
                                elm.find('tbody:first tr.checked-rows:has([type="checkbox"]:not(:checked))').remove();

                                const newData = (elm.getThisElementsData()).concat(new_html.getThisElementsData());
                                if (newData.length > 0) {
                                    elm.setThisElementsData(newData);
                                }

                            } else {
                                elm.find('tr:has([type="checkbox"]:checked):not([data-data-str])').each(function() {
                                    $(this).setThisElementsData($(this).getThisElementsData());
                                });

                                for (let att, i = 0, atts = new_html[0].attributes, n = atts.length; i < n; i++) {
                                    att = atts[i];
                                    if (att.nodeName !== 'class') {
                                        elm.attr(att.nodeName, att.value);
                                    }
                                }

                                if (elm.find('tr[data-id]').length === 0 || elm.find('tr[data-id] [type="checkbox"]:checked').length === 0 || elm.is('[data-no-rows-check]')) {
                                    elm.html(new_html.html());
                                } else {
                                    if (elm.find('tr.count-wrapper').length > 0) {
                                        elm.find('tr.count-wrapper').replaceWith(new_html.find('tr.count-wrapper'));
                                    } else {
                                        elm.find('thead').prepend(new_html.find('tr.count-wrapper'));
                                    }

                                    fillRows(elm, new_html);
                                    updateOrderIfNeeded(elm, (url || ''), (last_url || ''));
                                }
                                elm.find('.check-whole-table').removeAttr('checked');

                                new_html = elm;
                            }
                            toggleSelectionCallouts(elm, cb);
                            if (elm.is('[data-special-checkbox]')) {
                                addLoadMoreButton(elm, cb);
                            }
                        }

                        //Set the attributes

                        //Attach an implied add-key
                        if (!elm.is('[data-add-key]')) {
                            // alert('aa');
                            var next = elm.next();
                            if (next.prop('tagName') === 'A' && next.hasClass('button')) {
                                var add_key = get_unique_id();
                                new_html.attr('data-add-key', add_key);
                                next.attr('data-' + add_key, 1);
                            }
                        } else {
                            const button = elm.next();
                            const add_key = elm.attr('data-add-key');
                            if (button.prop('tagName') === 'A' && button.hasClass('button') && !button.is(`[data-${add_key}]`)) {
                                button.attr('data-' + add_key, 1);
                            }
                        }

                        var add_keys = [
                            'add',
                            'secondary-add',
                        ];
                        add_keys.forEach(function (key) {

                            if (new_html.attr('data-' + key + '-key') != undefined) {
                                var add_button = elm.parents('.reveal').find('[data-' + new_html.attr('data-' + key + '-key') + ']');
                                if (new_html.find('[data-id]').length == 0 || new_html.attr('data-' + key + '-button-action') == undefined) {
                                    add_button.hide();
                                } else {
                                    add_button.attr('onclick', 'return ' + new_html.attr('data-' + key + '-button-action'));
                                    add_button.show();

                                    if (add_button.length === 1) {
                                        // Have to add a clone on top of the table
                                        // If there's a h3 on top of the table, make it flex, add a div, and put the button in there
                                        const h3 = elm.parent().find('h3');
                                        if (h3.length === 1) {
                                            h3.css({display: 'flex', justifyContent: 'space-between'});
                                            let div = h3.find('.table-title-buttons-wrapper');
                                            if (div.length === 0) {
                                                div = $('<div class="table-title-buttons-wrapper"></div>');
                                                h3.append(div);
                                            }
                                            add_button.css({ marginBottom: '0' });
                                            div.append(add_button.clone());
                                        } else if (new_html.find('[data-id]').length > 15) {
                                            elm.before(add_button.clone());
                                        }
                                    }
                                }
                            }
                        });

                        //Check for special selectors and reload them too
                        if (new_html.find('select').length > 0) {
                            new_html.find('select').each(function () {
                                var sel = $(this);
                                Array.prototype.slice.call(sel[0].attributes).forEach(function (item) {
                                    if (item.name.split('data-').length > 1 && item.name.split('-selector').length > 1) {
                                        var name = item.name.replace('data-', '');
                                        name = name.replace('-selector', '');
                                        eval('sel.' + name + 'Selector();');
                                        //sel.contactSelector();
                                    }
                                });
                            })
                        }


                        //Reload after uncheck of checked checkboxes
                        if (elm.find('input[type=checkbox]:checked').length > 0) {
                            elm.find('tbody:first').find('tr:has(input[type=checkbox]:checked)').bind('change.reloadNow', function () {
                                elm.reloadThisElement(cb);
                            });
                            elm.find('tbody:first').find('input[data-no-reload]').parents('tr').unbind('change');
                        }

                        // Make sure the checked items pass through from the form
                        if (elm.parents('form').length > 0 && current_page === 1) {
                            elm.find('[data-hidden-checked]').remove();
                            const items = elm[0]['checked_items'];
                            if (items !== undefined) {
                                let filters_key = elm.attr('data-filters-key');
                                if (filters_key === undefined) {
                                    filters_key = get_unique_id('data-filters-key');
                                    elm.attr('data-filters-key', filters_key);
                                }

                                const firstCheckbox = elm.find('tbody:first').find('input[type=checkbox]:first');
                                items.forEach(function (id) {
                                    const hidden_input = firstCheckbox.clone();

                                    hidden_input.attr('type', 'hidden');
                                    hidden_input.attr('data-' + filters_key + '-filter', 1);
                                    hidden_input.attr('value', id);
                                    hidden_input.attr('data-hidden-checked', 1);
                                    elm.find('thead').append(hidden_input);
                                });
                            }
                        }

                        // Add the checked items to the list in order to prevent losing items that are in the 30+ range
                        elm.find('input[type=checkbox]').unbind('change.addToSelection').bind('change.addToSelection', function () {
                            let id = $(this).val();
                            id = parseInt(id).toString() === id ? parseInt(id) : id;
                            let items = elm[0]['checked_items'] ? elm[0]['checked_items'] : [];

                            if ($(this).is(':checked')) {
                                items.push(parseInt(id));
                            } else {
                                items = items.filter(function (item) {
                                    return item !== id;
                                });
                            }

                            elm[0]['checked_items'] = items;
                        });


                        //Check for user input filters
                        if (elm.find(".list-filter-input").length > 0) {
                            var key = elm.attr('data-filters-key');
                            if (key == undefined) {
                                key = get_unique_id('data-filters-key');
                                elm.attr('data-filters-key', key);
                            }
                            elm.find(".list-filter-input").each(function () {
                                const input = $(this);
                                let event = ['text', 'password', 'email', 'number', 'date', 'search', 'tel', 'month', 'week'].indexOf(input.attr('type')) >= 0 ? 'keyup' : 'change';
                                if ($(this).is('textarea')) {
                                    event = 'keyup';
                                }
                                if (input.is('[onclick="init_and_open_datepicker(this)"]') || input.is('[data-datepicker]')) {
                                    event = 'change';
                                }
                                $(this).attr('data-' + key + '-filter', 1);
                                $(this).unbind('keyup.reloadElement change.reloadElement').bind(`${event}.reloadElement`, function () {
                                    elm.reloadThisElement(cb);
                                }.bind([elm]));
                            });
                        }


                        if (elm[0].custom_callbacks) {
                            elm[0].custom_callbacks.forEach(function (cb) {
                                if (typeof cb === 'function') {
                                    cb();
                                }
                            });
                        }

                        //Write new url values to reload-url
                        var add_parameters_to_url = function (data) {
                            var this_url = url.split('?');

                            //Override existing data values
                            if (this_url[1]) {
                                var parts = this_url[1].split('&');
                                for (var key in parts) {
                                    var p = parts[key].split('=');
                                    if (p[1]) {
                                        var k = p[0];
                                        var v = p[1];

                                        if (data[k] != undefined) {
                                            parts[key] = k + '=' + data[k];
                                            delete data[k];
                                        }
                                    }
                                }
                                this_url[1] = parts.join('&');
                            }
                            this_url = this_url.join('?');

                            //Add data values when not overridden
                            for (var key in data) {
                                var value = data[key];
                                if (value != undefined) {
                                    if (this_url.split('?').length == 1) {
                                        this_url = this_url + '?';
                                    } else {
                                        this_url = this_url + '&';
                                    }
                                    this_url = this_url + key + '=' + value;
                                }
                            }

                            elm.attr('data-reloadable-url', this_url);
                        };

                        //React to order by buttons
                        elm.find('a[href*="orderby"]').click(function (e) {
                            e.preventDefault();
                            var href = $(this).attr('href').split('?')[1];
                            if (href.substr(0, 1) == '&') {
                                href = href.substr(1);
                            }
                            var data = {};
                            var p = href.split('&');
                            for (var key in p) {
                                var row = p[key].split('=');
                                var k = row[0];
                                var v = row[1];
                                data[k] = v;
                            }


                            //Fetch the input
                            var inputs = {};
                            elm.find('[data-id]').each(function () {
                                var id = $(this).attr('data-id');
                                inputs[id] = [];
                                $(this).find(':input').each(function (i) {
                                    var v = $(this).val();
                                    if ($(this).is(':checkbox')) {
                                        v = $(this).is(':checked');
                                    }

                                    inputs[id][i] = v;
                                });
                            });

                            add_parameters_to_url(data);
                            elm.reloadThisElement(function () {
                                //Re-set the input
                                var elm = $('#' + uid);
                                for (var id in inputs) {
                                    var row = inputs[id];

                                    if (elm.find('[data-id="' + id + '"]').length > 0) {
                                        elm.find('[data-id="' + id + '"]').find(':input').each(function (i) {
                                            if (row[i]) {
                                                if (!$(this).is(':checkbox')) {
                                                    $(this).val(row[i]);
                                                } else if ($(this).is(':checkbox') && row[i] == true) {
                                                    $(this)[0].checked = true;
                                                }
                                            }
                                        });
                                    }

                                }

                                if (cb != undefined) {
                                    cb();
                                }
                            }.bind(cb));
                            return false;
                        });

                        //Search if, searchbar is available
                        if (elm.find('input[type="search"]').length > 0) {
                            var searchbar = elm.find('input[type="search"]');
                            searchbar.unbind('keyup').keyup(function (e) {
                                add_parameters_to_url({'s': $(this).val()});

                            }).unbind('keydown').keydown(function (e) {
                                if (e.keyCode == 13) {
                                    elm.reloadThisElement(function () {
                                        elm.find('input[type="search"]').select().focus();
                                        if (cb != undefined) {
                                            cb();
                                        }
                                    });
                                    return false;
                                }
                            });
                        }

                        //Paginate it with endless scroll if needed
                        if (!elm.is('[data-no-paginator]')) {
                            let parent = elm.parents('.reveal-overlay');
                            if (parent.length === 0) {
                                parent = elm.parents('.table-wrapper');
                            }
                            parent.unbind('scroll.' + uid).bind('scroll.' + uid, function (e) {
                                const uid = e.handleObj.namespace;
                                const elm = $('#' + uid);
                                if (elm.length === 0 || !elm.is(':visible')) {
                                    $(this).unbind('scroll.' + uid);
                                    return;
                                }
                                if (elm.find('tbody:first tr[data-id]:not(.checked-rows)').length === parseInt(elm.attr('data-total-count')) ||
                                    parseInt(parseFloat(elm.find('tbody:first tr[data-id]:not(.checked-rows)').length / max_per_page) * 100) !== parseInt(elm.find('tbody:first tr[data-id]:not(.checked-rows)').length / max_per_page) * 100) {
                                    elm[0].done = true;
                                    return;
                                }
                                if ($(this).next().is(':visible').length > 0) {
                                    return;
                                }
                                if (elm[0].is_loading === true || elm[0].done) {
                                    return;
                                }
                                if (elm.is('[data-special-checkbox]') && elm.find('tr[data-id] :checked').length > 0) {
                                    return;
                                }
                                const s_h = $(this).height();
                                const s = $(this).scrollTop();
                                let h;
                                if (parent.hasClass('reveal-overlay')) {
                                    h = $(this).find('.reveal:first').outerHeight(true) + parseInt($(this).find('.reveal:first').css('top'));
                                } else {
                                    h = parent.height();
                                }

                                const diff = h - s_h;

                                if ((s / diff) > 0.9) {
                                    elm.reloadThisElement(cb, (elm[0].current_page + 1));
                                }
                            });
                        }


                        elm.trigger('onReload');
                        elm.doneLoading();
                    }.bind([elm, cb, reveal])).fail(function (xhr, status, error) {
                        if (error != "abort") {
                            elm.doneLoading();
                            squde_flash("Er ging iets mis met het laden van de data", "alert");
                        }
                    }).always(function () {
                        elm[0].is_loading = false;
                        elm.doneLoading();
                    });
                }
            }

            if (elm[0].debouncedFn !== undefined) {
                elm[0].debouncedFn.cancel();
            }

            elm[0].debouncedFn = _.debounce(load, 500);
            elm[0].debouncedFn();
        });
        if (getRequestData) {
            return requestData;
        }
        return this;
    };

    $.fn.getThisElementsData = function () {
        let elm = $(this);
        let row = false;
        let index = 0;
        let tr;
        if (elm.prop('tagName') === 'TR' && !elm.is('[data-data-str]')) {
            row = true;
            tr = elm;
            index = (() => {
                let foundIndex;
                elm.parents('table').find('[data-id]').each(function(i) {
                    if ($(this).index() === tr.index()) {
                        foundIndex = i;
                    }
                });
                return foundIndex;
            })();
            elm = elm.parents('table');
        }

        const data_str = elm.attr('data-data-str');
        try {
            let json;

            try {
                json = decodeURIComponent(atob(data_str))
            } catch (e) {
                json = atob(data_str);
            }

            const data = JSON.parse(json);

            if (row === true) {
                if (data[index]) {
                    return data[index];
                } else {

                    return null;
                }
                return null;
            }

            return data;
        } catch (e) {
            return data_str;
        }
    };

    $.fn.setThisElementsData = function (data) {
        let elm = $(this);

        const str = JSON.stringify(data);
        elm.attr('data-data-str', btoa(encodeURIComponent(str)));
        return elm;
    };

    $.fn.reloadThisRow = function (reOrder = false) {
        const trs = $(this);

        const tables = {};
        let ids = [];
        trs.each(function () {
            const tr = $(this);
            const table = tr.parents('table');
            if (table.length === 0) {
                return;
            }
            let uid = table.attr('data-uid');
            if (!uid) {
                uid = get_unique_id('data-uid');
                table.attr('data-uid', uid);
            }
            if (!tables[uid]) {
                tables[uid] = table;
            }
            ids.push($(this).attr('data-id'));
        });
        ids = ids.filter( (value, index, self) => {
            return self.indexOf(value) === index;
        });

        Object.values(tables).forEach((table) => {
            table.attr('data-last-single-update', (new Date()).getTime());

            let url = table[0].last_url;
            if (!url) {
                url = window.location.toString();
            }

            url = url + (url.split('?').length === 1 ? '?' : '&') + 'onlyGet=' + ids;
            const type = table.attr('data-request-type') === undefined ? 'GET' : table.attr('data-request-type');
            const data = type === 'GET' ? {} : table[0]['last_data'];
            $.ajax({
                url,
                type,
                data
            }).done((html) => {
                html = $(html);
                ids.forEach((id) => {
                    const tr = table.find('tr[data-id="' + id + '"]');
                    const newTr = html.find('tr[data-id="' + id + '"]');

                    if (tr.length === 0) {
                        return;
                    }

                    $.each(tr[0].attributes, function () {
                        try {
                            // this.attributes is not a plain object, but an array
                            // of attribute nodes, which contain both the name and value
                            if (this.specified) {
                                newTr.attr(this.name, this.value);
                            } else {
                                newTr.attr(this.name, this.name);
                            }
                        } catch (e) {
                            //
                        }
                    });


                    newTr.insertAfter(tr);

                    tr.find('input').each(function() {
                        const input = $(this);
                        const name = input.attr('name');
                        const type = input.attr('type');
                        if (!name) {
                            return;
                        }
                        const newInput = newTr.find('input[name="' + name.split('[').join('\[').split(']').join('\]') + '"][type="' + type + '"]');
                        if (type === 'checkbox') {
                            if (input.is(':checked')) {
                                newInput.attr('checked', 'checked');
                            } else {
                                newInput.removeAttr('checked');
                            }
                        } else {
                            newInput.val(input.val());
                        }
                        newInput.trigger('change').trigger('keyup');
                    });

                    tr.remove();
                });

                table.trigger('onReload');
            });
        });


        return this;
    };

    function fillRows(elm, new_html) {
        const tbody = elm.find('tbody:first');

        tbody.find('tr:has([type="checkbox"]:checked)').addClass('checked-rows');

        tbody.find('tr:has([type="checkbox"]:not(:checked))').remove();

        new_html.find('tr[data-id]').each(function(index) {
            const clone = $(this).clone(true,true);
            tbody.append(clone);
            const checkedRow = tbody.find('tr[data-id="' + clone.attr('data-id') + '"].checked-rows');
            if (checkedRow.length > 0) {
                checkedRow.find(':checked[name]').each(function() {
                    const name = $(this).attr('name');
                    clone.find('input[name="' + name.split('[').join('\[').split(']').join('\]') + '"]').each(function() {
                        $(this).attr('checked', 'checked');
                    });
                });
                checkedRow.remove();
            }
        });

        tbody.find('.checked-rows').each(function() {
            tbody.append($(this));
        });
    }
    function updateOrderIfNeeded(elm, url, last_url) {
        console.log({ elm, url, last_url });
        const parseString = function (querystring = '') {
            // remove any preceding url and split
            querystring = querystring.substring(querystring.indexOf('?')+1).split('&');
            let params = {}, pair, d = decodeURIComponent;
            // march and parse
            for (let i = querystring.length - 1; i >= 0; i--) {
                pair = querystring[i].split('=');
                params[d(pair[0])] = d(pair[1] || '');
            }

            return params;
        };
        const formerData = parseString('?' + last_url.split('?')[1]);
        const currentData = parseString('?' + url.split('?')[1]);

        if (currentData.order !== formerData.order || currentData.orderby !== formerData.orderby) {
            elm.find('tr[data-id]:has(:checked)').reloadThisRow(true);
        }
    }
    function toggleSelectionCallouts(elm, callback) {
        const $ = jQuery.noConflict();
        if (elm.is('[data-no-paginator]')) {
            elm.find('tr[data-id].checked-rows').remove();
            return;
        }
        const firstSelectedRow = elm.find('tr[data-id].checked-rows:first');
        /**
         * First of all, add an extra row which says there is a selection involved on the bottom
         */
        const extraRow = function() {
            const rowClass = 'selection-starts-here';
            elm.find('tr.' + rowClass).remove();

            if (firstSelectedRow.length === 0) {
                return;
            }

            const tr = createTextRow(elm, rowClass, 'Overige selectie (' + elm.find('.checked-rows').length + ')');

            firstSelectedRow.before(tr);
        }();

        /**
         * Here you set a callout on top of the table if there are other results than what you've checked
         */
        const topCallout = function() {
            let addDiv = false;
            const rowClass = 'has-checkboxes-indicator';
            elm.find('tr.' + rowClass).remove();

            const thead = elm.find('thead:first');
            const div = $('<div></div>');
            const count = elm.find('.checked-rows').length;
            const betweenSpan = $('<span> | </span>');

            if(count > 0 && elm.find('tr[data-id]:not(.checked-rows)').length > 0) {
                addDiv = true;
                div.prepend('<span>Er ' + (count === 1 ? 'valt één item' : 'vallen ' + count + ' items') + ' buiten de filters.</span><br />');
                const scrollLink = $('<a href="#">Scroll naar overige selectie</a>');
                scrollLink.click(function() {
                    const top = firstSelectedRow.offset().top;
                    elm.parents('.reveal-overlay:first').animate({scrollTop: top}, 250);
                    return false;
                });
                div.append(scrollLink);
            }

            if (elm.find('.check-whole-table').is(':checked')) {
                addDiv = true;
                const thisCount = elm.find('tr[data-id]:not(.checked-rows):has(:checked)').length;
                const html = '<span>Er ' + (thisCount === 1 ? 'is één item' : 'zijn ' + thisCount + ' items') + ' geselecteerd binnen de huidige filters.</span><br />';
                if (div.find('span').length > 0) {
                    div.find('span + br').after(html);
                } else {
                    div.prepend(html);
                }
                const maxPerPage = elm.attr('data-max-per-page') === undefined ? 30 : parseInt(elm.attr('data-max-per-page'));
                const totalCount = parseInt(elm.attr('data-total-count'));
                const numberLeft = totalCount - elm.find('tr[data-id]:not(.checked-rows)').length;
                if (numberLeft > 0) {
                    let addAFewCount = numberLeft;
                    if (numberLeft > maxPerPage) {
                        addAFewCount = maxPerPage;
                    }
                    const addAFewLink = $('<a href="#" class="add-a-few">Voeg volgende ' + addAFewCount + ' toe</a>');
                    addAFewLink.click(function() {
                        loadAndCheckNext(elm, callback);
                        return false
                    });

                    if (div.find('a:last').length > 0) {
                        const span = betweenSpan.clone();
                        div.find('a:last').after(span);
                        span.after(addAFewLink);
                    } else {
                        div.append(addAFewLink);
                    }

                    if (numberLeft > maxPerPage) {
                        const addRestLink = $('<a href="#" class="add-them-all" title="Dit kan even duren">Voeg alle overige ' + numberLeft + ' toe</a>');
                        addRestLink.click(function() {
                            if (elm[0].custom_callbacks) {
                                elm[0].custom_callbacks = elm[0].custom_callbacks.filter((cb) => {
                                    return cb.toString() !== 'function(){callback();}';
                                });
                            }

                            const setPercentage = (thisCount, totalCount) => {
                                const percentage = Math.round(thisCount / totalCount * 100);
                                let progressSpan = elm.parent().children('.progress-span');
                                if (progressSpan.length === 0) {
                                    progressSpan = $('<span class="progress-span" data-value="0"></span>');
                                    elm.before(progressSpan);
                                }
                                setTimeout(() => {
                                    progressSpan.attr('data-value', percentage);
                                });
                            };
                            setPercentage(parseFloat(elm.find('tr[data-id]:not(.checked-rows):has(:checked)').length), parseFloat(totalCount));

                            const loadingElm = elm.parents('.reveal');
                            loadingElm.isLoading('on-top');
                            loadAndCheckNext(elm, () => {
                                setPercentage(parseFloat(elm.find('tr[data-id]:not(.checked-rows):has(:checked)').length), parseFloat(totalCount));

                                if (elm.find('.add-a-few').length > 0) {
                                    loadAndCheckNext(elm);
                                } else {
                                    topCallout();
                                    if (callback) {
                                        callback();
                                    }
                                    loadingElm.doneLoading();
                                    elm.parent().children('.progress-span').remove();
                                }
                            });
                            return false;
                        });
                        if (div.find('a:last').length > 0) {
                            const span = betweenSpan.clone();
                            div.find('a:last').after(span);
                            span.after(addRestLink);
                        } else {
                            div.append(addRestLink);
                        }
                    }
                }
            }

            if (addDiv) {
                div.find('> *').css({marginRight: '5px'});

                const tr = createTextRow(elm, 'has-checkboxes-indicator', div, 'warning text-left');

                thead.append(tr);
            }
        };
        topCallout();

        elm.find('.check-whole-table').unbind('change.top-callout').bind('change.top-callout', topCallout);
    }

    function addLoadMoreButton(elm, callback) {
        if(!callback) {
            callback = function() {};
        }
        elm.find('.load-more-button-wrapper').remove();
        const totalCount = parseInt(elm.attr('data-total-count'));
        const numberLeft = totalCount - elm.find('tr[data-id]:not(.checked-rows)').length;
        if (numberLeft > 0 && elm.find('tr[data-id]:has(:checked)').length > 0) {
            const tbody = elm.find('tbody:first');
            const div = $('<div><b>Laad meer...</b></div>');
            const row = createTextRow(elm, 'load-more-button-wrapper', div, 'warning text-center');
            tbody.find('tr[data-id]:not(.checked-rows):last').after(row);
            row.css({
                cursor: 'pointer'
            });
            row.click(function() {
                loadNext(elm, callback);
                return false;
            });
        }
        elm.find('tr[data-id] input[type="checkbox"]').unbind('change.toggle-load-more-button').bind('change.toggle-load-more-button', function() {
            addLoadMoreButton(elm, callback);
        });
    }

    function createTextRow(elm, rowClass, html, calloutClasses = 'warning text-center') {
        const tr = $('<tr class="' + rowClass + '"></tr>');
        const td = $('<td></td>');
        td.attr('colspan', elm.find('tr[data-id]:first').find('td').length);
        td.html('<div class="callout ' + calloutClasses + '"></div>');
        td.find('div').html(html).css({margin: 0});
        tr.html(td);
        return tr;
    }
    function loadAndCheckNext(elm, callback) {
        loadNext(elm, () => {
            elm.find('tr[data-id]:not(.checked-rows) input[type="checkbox"]:not([disabled]):not([readonly])').attr('checked', 'checked');
            elm.find('.check-whole-table').trigger('change.top-callout');
            if (callback) {
                callback();
            }
        });
    }
    function loadNext(elm, callback) {
        elm.reloadThisElement(() => {
            callback();
        }, (elm[0].current_page + 1));
    }
}(jQuery));

function reloadRowsOfType(type, id) {
    const $ = jQuery.noConflict();

    // 1) Reload everything that has [data-object-type="{type}"][data-id="{id}"]
    // 2) Reload everything that has [data-{type}_id="{id}]
    // 3) Reload everything that contains onclick="return view_{type}({id}*"
    const trs = [];
    $('[data-object-type="' + type + '"][data-id="' + id + '"], [data-' + type + '_id="' + id + '"], [onclick^="return view_' + type + '(' + id + '\,"], [onclick^="return view_' + type + '(' + id + ')"]').each(function () {
        let elm = $(this);
        if (elm.prop('tagName') !== 'TR') {
            elm = elm.parents('tr');
        }
        if (elm.length > 0) {
            trs.push(elm);
        }
    });
    $(trs).reloadThisRow();
}
